export default {
  MuiButton: {
    root: {
      textTransform: "none",
    },
  },
  MuiTouchRipple: {
    root: {
      display: "none",
    },
  },
};
